import { Injectable } from '@angular/core';
import { ProjectPermissionModal } from '../../Model/projectPermission/projectPermissionModal';
import { ServiceRepository } from '../service-repository';

@Injectable({
  providedIn: 'root'
})
export class ProjectPermissionService {

  constructor(
    private _repositoryService: ServiceRepository
  ) { }

  getUserProjectPermission(projectPermissionDetails: ProjectPermissionModal, loggedInUserId: string){
    return this._repositoryService
    .createWithBody('/api/UserProjectMgmt/usersProjectPermission/' + loggedInUserId, projectPermissionDetails)
  }

  getClients(appType:string,loggedInUserId:string){
    return this._repositoryService.getDatawitHeaders('/api/UserProjectMgmt/getClientDetails/'+appType+'/'+loggedInUserId)
  }

  getProject(clientId:string,appType:string,loggedInUserId:string){
    return this._repositoryService.getDatawitHeaders('/api/UserProjectMgmt/getProjectDetails/'+clientId+'/'+appType+'/'+loggedInUserId)
  }

  getProjectAccessUsers(projectId:string,isExcludeProjectUser:string,loggedInUserId:string){
    return this._repositoryService.getDatawitHeaders('/api/UserProjectMgmt/getProjectAccessUsers/'+projectId+'/'+isExcludeProjectUser+'/' + loggedInUserId)
  }

  RevokeUserProjectAccess(projectId:string, revokedUser: string, loggedInUserId: string){
    return this._repositoryService.getDatawitHeaders('/api/UserProjectMgmt/revokeUserProjectAccess/'+projectId+'/'+ revokedUser+'/' + loggedInUserId)
  }
}
